export default {"src":"/_next/static/media/LL_blacklogo.c6beb61e.svg","height":373,"width":373};